import { NgModule } from "@angular/core";
import { PISuggestionDrawerModule } from "./suggestion-drawer/suggestion-drawer.module";
import { PISuggestionStateIndicatorModule } from "./suggestion-state-indicator/suggestion-state-indicator.module";

@NgModule({
  imports: [PISuggestionStateIndicatorModule, PISuggestionDrawerModule],
})
export class PIExpandableSuggestionsModule {}
